/* eslint-disable */
var React = require('react');
var SpriteSymbol = require("../../../svg-baker-runtime/browser-symbol.js");
var sprite = require("../../../svg-sprite-loader/runtime/browser-sprite.build.js");

var symbol = new SpriteSymbol({
  "id": "checkmark-knockout-bf2cb004--sprite",
  "use": "checkmark-knockout-bf2cb004--sprite-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 36 36\" id=\"checkmark-knockout-bf2cb004--sprite\"><g fill=\"#fff\" stroke=\"#707070\" stroke-width=\"1\" opacity=\"0\"><rect width=\"36\" height=\"36\" stroke=\"none\" /><rect x=\"0.5\" y=\"0.5\" width=\"35\" height=\"35\" fill=\"none\" /></g><g transform=\"translate(21.664 -199.002)\"><path d=\"M-3.664,205a11.962,11.962,0,0,0-8.49,3.51,12,12,0,0,0-3.51,8.49,11.956,11.956,0,0,0,3.51,8.48A11.971,11.971,0,0,0-3.664,229a11.971,11.971,0,0,0,8.49-3.52A11.956,11.956,0,0,0,8.336,217,12,12,0,0,0-3.664,205Zm4.98,10.27-6.45,6.46v.01a1,1,0,0,1-1.42-.01l-2.72-2.72a1.325,1.325,0,0,1-.39-.94,1.325,1.325,0,0,1,.39-.94,1.328,1.328,0,0,1,1.88,0l1.55,1.54,5.28-5.28h.01a1.328,1.328,0,0,1,1.88,0A1.319,1.319,0,0,1,1.316,215.271Z\" fill=\"currentColor\" /></g></symbol>"
});
sprite.add(symbol);

var SvgSpriteIcon = function SvgSpriteIcon(props) {
  return React.createElement(
    'svg',
    Object.assign({
      viewBox: symbol.viewBox
    }, props),
    React.createElement(
      'use',
      {
        xlinkHref: '#' + symbol.id
      }
    )
  );
};

SvgSpriteIcon.viewBox = symbol.viewBox;
SvgSpriteIcon.id = symbol.id;
SvgSpriteIcon.content = symbol.content;
SvgSpriteIcon.url = symbol.url;
SvgSpriteIcon.toString = symbol.toString;

module.exports = SvgSpriteIcon;
module.exports.default = SvgSpriteIcon;
